import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=389290f2&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"
import style0 from "./SocialIcons.vue?vue&type=style&index=0&id=389290f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389290f2",
  null
  
)

export default component.exports